import { api } from 'api'
import { WorkStatusEnum } from './shiftTimeline'

type GetLedShiftsRequest = {
  companyId: number
  shiftId: number
}

type GetLedShiftsResponseWork = {
  status: WorkStatusEnum
  worker: {
    id: number
    name: string
    profilePicUrl?: string
  }
  confirmedAt?: string
  startedAt?: string
  supervisorMarkedNoShow?: boolean
}

type GetLedShiftsResponseLedShift = {
  id: number
  startsAt: string
  endsAt: string
  workersNeeded: number
  position: {
    id: number
    name: string
  }
  location?: {
    id: number
    name: string
    timezone?: string
  }
  work: GetLedShiftsResponseWork[]
}

type GetLedShiftsResponse = {
  ledShifts: GetLedShiftsResponseLedShift[]
}

export async function getLedShifts(
  { companyId, shiftId }: GetLedShiftsRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetLedShiftsResponse>(
    `/company/${companyId}/shifts/${shiftId}/led_shifts`,
    { signal }
  )

  return response.data.ledShifts
}
